export const showMenu = () => {
    return {
        type: "SHOW_MENU",
    };
};

export const hideMenu = () => {
    return {
        type: "HIDE_MENU",
    };
};

export const toggleMenu = () => {
    return {
        type: "TOGGLE_MENU",
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/menu.js